import { TransactionDataTypeEnum, TransactionTypeEnum } from '@/services/types/TransactionData';
import { EnumValues } from '@/services/types/EnumValues';

export type TTransactionFilter = {
  displayName: string;
  type: EnumValues<typeof TransactionDataTypeEnum> | null;
  transactionType: EnumValues<typeof TransactionTypeEnum>;
};

const transactionTypes: TTransactionFilter[] = [
  {
    displayName: 'Account transfer',
    type: null,
    transactionType: TransactionTypeEnum.Transfer
  },
  {
    displayName: 'Purchase',
    type: null,
    transactionType: TransactionTypeEnum.Purchase
  },
  {
    displayName: 'Outgoing bank transfer',
    type: TransactionDataTypeEnum.Outgoing,
    transactionType: TransactionTypeEnum.Bank
  },
  {
    displayName: 'Incoming bank transfer',
    type: TransactionDataTypeEnum.Incoming,
    transactionType: TransactionTypeEnum.Bank
  },
  {
    displayName: 'Admin',
    type: null,
    transactionType: TransactionTypeEnum.Admin
  },
  {
    displayName: 'Top up',
    type: null,
    transactionType: TransactionTypeEnum.TopUp
  },
  {
    displayName: 'EmergePay',
    type: null,
    transactionType: TransactionTypeEnum.EmergePay
  }
];

export { transactionTypes };
